import React from "react"
import pdfIcon from "../assets/doc_icons/pdf.svg"
import imageIcon from "../assets/doc_icons/image.svg"
import docsIcon from "../assets/doc_icons/docx2.svg"
import excelIcon from "../assets/doc_icons/excel.svg"
import videoIcon from "../assets/doc_icons/video.svg"
import documentIcon from "../assets/doc_icons/document.svg"
import imageIcon2 from "../assets/doc_icons/image2.svg"
import filmIcon from "../assets/doc_icons/film.svg"
import Cookies from "js-cookie"

const domains = {
  "prod": "backrr.com",
  "dev": "bkrr.net",
  "local": "localhost",
}

const domainsForCookies = {
  [domains["prod"]]: "." + domains["prod"],
  [domains["dev"]]: "." + domains["dev"],
  [domains['local']]: domains['local']
};

const subDomains = {
  "investor": "investor",
  "startup": "startup",
  "main": ""
}

const bucketUrls = {
  "prod": "https://investors-prod-pub.s3.ap-south-1.amazonaws.com/investors_media/",
  "dev": "https://investors-dev-pub.s3.ap-south-1.amazonaws.com/investors_media/",
  "local": "https://investors-dev-pub.s3.ap-south-1.amazonaws.com/investors_media/",
}

const getBucketUrl = () => {
  switch (process.env.REACT_APP_MODE) {
    case "production": return bucketUrls["prod"];
    case "development": return bucketUrls["dev"];
    // default: return bucketUrls["dev"];

  }
}

function extractMainDomain(url) {
  try {
    // Add protocol if missing
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }

    const hostname = new URL(url).hostname.replace(/^www\./i, '');
    const parts = hostname.split('.');

    // If only 2 parts like "example.com"
    if (parts.length === 2) {
      return hostname;
    }

    // For domains like "sub.example.co.in", "a.b.c.d.e.site.xyz", etc.
    // Get last 2 parts as fallback domain
    return parts.slice(-2).join('.');
  } catch (e) {
    return null;
  }
}


const dealFlowStatuses = [
  {
    label: 'New',
    value: "invited"
  },
  {
    label: 'Shortlisted',
    value: "interested"
  },
  {
    label: 'Selected',
    value: "in-progress"
  },
  {
    label: 'Rejected',
    value: "rejected"
  }
]

const navigateToDomain = (type = "main", pathname) => {
  let domain = checkForDomain();
  // console.log(domain)
  if (type === "main") {
    if (process.env.REACT_APP_MODE === "production") {
      return "https://" + domains["prod"] + "/" + pathname
    }
    else {
      return "https://" + domains["dev"] + "/" + pathname
    }
    // window.open(domain)
  }
  else if (type === "investor") {
    if (process.env.REACT_APP_MODE === "production") {
      return "https://" + subDomains["investor"] + "." + domains["prod"] + "/" + pathname
    }
    else {
      return "https://" + subDomains["investor"] + "." + domains["dev"] + "/" + pathname
    }
  }
  else if (type === "startup") {
    if (process.env.REACT_APP_MODE === "production") {
      return "https://" + subDomains["startup"] + "." + domains["prod"] + "/" + pathname
    }
    else {
      return "https://" + subDomains["startup"] + "." + domains["dev"] + "/" + pathname
    }
  }
  else {
    if (process.env.REACT_APP_MODE === "production") {
      return "https://" + domains["prod"] + "/" + pathname
    }
    else {
      return "https://" + domains["dev"] + "/" + pathname
    }
  }
  // const resultDomain = type === "main" ? process.env.REACT_APP_MODE === "production" ? String(domain)?.substring(1, String(domain)?.length) : domains["dev"] : domains["dev"];
  // console.log(type, resultDomain,)
  // window.open(resultDomain)
  // window.open(domain?.includes(domains?.prod) ? ("https://" + subDomains[type] + resultDomain) : ("https://" + subDomains[type] + resultDomain))
}

const chartsColorsTheme = [
  "rgba(66, 133, 244, 0.9)",  // Blue
  "rgba(170, 70, 187, 0.9)",  // Purple
  "rgba(15, 157, 88, 0.9)",   // Green
  "rgba(50, 68, 155, 0.9)",   // Red
  "rgba(255, 111, 0, 0.9)",   // Orange
  "rgba(165, 115, 60, 0.9)",  // Brown
  "rgba(255, 204, 0, 0.9)",   // Yellow
  "rgba(255, 0, 255, 0.9)",   // Pink
  "rgba(0, 195, 227, 0.9)"    // Cyan
];

const handleDateValues = (date, placeholder = "No Date") => {
  return date && String(date)?.trim()?.length > 0 ? date : placeholder
}


function getDeviceType() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for iOS devices
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  // Check for Android devices
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // Default to web-desktop for other cases
  return 'web';
}

export const checkForDomain = () => {
  const domain = window.location.hostname;
  // console.log(domain, "domain"

  // Loop through the keys of the object and check if the domain includes any of them
  for (let key in domainsForCookies) {
    if (domain.includes(key)) {
      return domainsForCookies[key]; // Return the value corresponding to the matching key
    }
  }

  // If no match, return a default value (optional)
  return domain; // Default value
}

const checkForEmail = () => {
  return Cookies.get("email")
}

// this redirect to another portal
function redirectTo(host) {
  switch (process.env.REACT_APP_MODE === "production") {
    case true:
      if (process.env.REACT_APP_PORTAL === "startup") {
        window.open("https://" + subDomains["investor"] + "." + domains["prod"], "_blank");
      }
      else if (process.env.REACT_APP_PORTAL === "investor") {
        window.open("https://" + subDomains["startup"] + "." + domains["prod"], "_blank");
      }
      break;
    default:
      if (process.env.REACT_APP_PORTAL === "startup") {
        window.open("https://" + subDomains["investor"] + "." + domains["dev"], "_blank");
      }
      else if (process.env.REACT_APP_PORTAL === "investor") {
        window.open("https://" + subDomains["startup"] + "." + domains["dev"], "_blank");
      }
      break;
  }
  return null
}

function navigateToMain(host, returnType = "open") {
  if (returnType === "return") {
    if (process.env.REACT_APP_MODE === "production") {
      return "https://" + domains["prod"]
    }
    else {
      return "https://" + domains["dev"]
    }
  }
  else {
    if (process.env.REACT_APP_MODE === "production") {
      window.location.href = "https://" + domains["prod"]
    }
    else {
      window.location.href = "https://" + domains["dev"]
    }
  }
}

function singleSignOn(host, type) {
  if (process.env.REACT_APP_MODE === "production") {
    if (type === "startup") {
      return "https://" + subDomains["startup"] + "." + domains["prod"]
    }
    else if (type === "investor") {
      return "https://" + subDomains["investor"] + "." + domains["prod"]
    }
    else {
      return null
    }
  }
  else {
    if (type === "startup") {
      return "https://" + subDomains["startup"] + "." + domains["dev"]
    }
    else if (type === "investor") {
      return "https://" + subDomains["investor"] + "." + domains["dev"]
    }
    else {
      return null
    }
  }
}

const getFileIcon = (fileName) => {
  const extension = fileName?.split('.')?.pop()?.toLowerCase();

  switch (extension) {
    case 'pdf':
      return pdfIcon; // Replace with actual path to your PDF icon image
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'svg':
      return imageIcon; // Replace with actual path to your image icon
    case 'doc':
    case 'docx':
      return docsIcon; // Replace with actual path to your DOC/DOCX icon
    case 'xls':
    case 'xlsx':
    case 'csv':
      return excelIcon; // Replace with actual path to your Excel icon
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'mkv':
    case 'wmv':
      return videoIcon; // Replace with actual path to your video icon
    default:
      return docsIcon; // Replace with actual path to a default icon for unsupported types
  }
};

//   // Example usage
//   const fileName = 'example.pdf';
//   const iconPath = getFileIcon(fileName);
//   console.log(iconPath); // Outputs the path to the corresponding icon based on the file extension

const getFileCategory = (fileName) => {
  const extension = fileName?.split('.')?.pop()?.toLowerCase();

  switch (extension) {
    case 'pdf':
    case 'doc':
    case 'docx':
    case 'xls':
    case 'xlsx':
    case 'csv':
    case 'ppt':
    case 'pptx':
    case 'txt':
      return documentIcon; // Category for document files

    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'svg':
      return imageIcon2; // Category for image files

    case 'mp4':
    case 'mov':
    case 'avi':
    case 'mkv':
    case 'wmv':
    case 'flv':
      return filmIcon; // Category for video files

    default:
      return documentIcon; // Default case for unsupported or unknown file types
  }
};

//   // Example usage
//   const fileName = 'example.mp4';
//   const fileCategory = getFileCategory(fileName);
//   console.log(fileCategory); // Outputs 'video'

const currencyInputProps = {
  inputMode: "numeric", // Use numeric keyboard on mobile devices
  pattern: "[0-9]*", // Only allow digits 0-9
  // title: "Please enter a number between 0 and 9",
  style: {
    // textAlign: 'center', // Center the text in the input
  },
  min: 0,
  onKeyDown: (event) => {
    // Prevent the minus sign (-) from being entered
    if (event.key === "-") {
      event.preventDefault();
    }
  },
  onKeyPress: (event) => {
    // Prevent any input when the minus key is pressed, as it was already prevented in the onKeyDown event
    if (event.key === "-") {
      event.preventDefault();
    }
  },
  onKeyPress: (event) => {
    // Get the input value
    const inputValue = event.key;

    // Allow only numeric characters (0-9) and certain control keys
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
    ];

    // Check if the pressed key is in the allowedKeys array
    if (!allowedKeys.includes(inputValue)) {
      // If not, prevent the key from being entered
      event.preventDefault();
    }
  },
  onInput: (event) => {
    // Get the input value
    const inputValue = event.target.value;

    // Remove non-numeric characters using a regular expression
    const numericValue = inputValue.replace(/[^0-9]/g, "");

    // Update the input field value with the filtered numeric value
    event.target.value = numericValue;
  },
  onKeyDown: (event) => {
    // Prevent the input of minus sign (key code 189)
    if (event.keyCode === 189 || event.key === "-") {
      event.preventDefault();
    }
  },
  disableUnderline: true,
};

// const formatAllowsNegativeCurrency = (value, locale = "en-In") => {
//   if (!value) return "";

//   // Remove invalid characters except numbers, decimal, and negative sign
//   const cleanValue = String(value)?.replace(/[^0-9.-]/g, "");

//   // Ensure only the first `-` is kept and at the start
//   const isNegative = cleanValue.startsWith("-");
//   const numericValue = cleanValue.replace(/-/g, ""); // Remove all `-` signs
//   const sanitizedValue = isNegative ? `-${numericValue}` : numericValue;

//   // Allow only two digits after the decimal point
//   const parts = sanitizedValue.split(".");
//   if (parts.length > 1) {
//     parts[1] = parts[1].slice(0, 2); // Keep only the first 2 digits after '.'
//   }

//   // Join the integer and decimal parts back
//   const truncatedValue = parts.join(".");

//   // Format the integer part with commas
//   const [integerPart, decimalPart] = truncatedValue.split(".");
//   const formattedInteger = parseInt(integerPart || "0", 10).toLocaleString(locale);

//   return decimalPart !== undefined
//     ? `${formattedInteger}.${decimalPart}`
//     : formattedInteger;
// };

const versionInputProps = {
  inputMode: "decimal", // Use numeric keyboard with decimal support on mobile devices
  pattern: "[0-9.]*", // Allow digits 0-9 and '.'
  min: 0,
  onKeyDown: (event) => {
    const { key, target } = event;

    // Prevent the minus sign (-), 'e', or 'E'
    if (key === "-" || key === "e" || key === "E") {
      event.preventDefault();
    }

    // Prevent more than two '.' characters
    if (key === "." && (target.value.match(/\./g)?.length || 0) >= 2) {
      event.preventDefault();
    }
  },
  onInput: (event) => {
    const inputValue = event.target.value;

    // Allow only numbers and periods
    const numericValue = inputValue.replace(/[^0-9.]/g, "");

    // Ensure a maximum of two '.' characters
    const parts = numericValue.split(".");
    const formattedValue = parts.slice(0, 3).join(".");

    // Update the input field value
    event.target.value = formattedValue;
  },
  style: {
    textAlign: "center", // Optional: Center the text
  },
  disableUnderline: true,
};

function versionCheck({ latestVersion: v1, currentVersion: v2 }) {
  // console.log(v1,v2, "before split")
  const arr1 = v1 ? v1?.split('.')?.map(Number) : v2;
  const arr2 = v2?.split('.')?.map(Number);
  // console.log(v1,v2, "after split")

  for (let i = 0; i < Math.max(arr1?.length, arr2?.length); i++) {
    const num1 = arr1[i] || 0; // Default to 0 if undefined
    const num2 = arr2[i] || 0;

    if (num1 > num2) return true;  // v1 is greater
    if (num1 < num2) return false; // v2 is greater
  }
  return false; // Versions are equal
}


const containerRef = (ref) => {
  if (ref) {
    // https://github.com/mdbootstrap/perfect-scrollbar/pull/934/files
    ref._getBoundingClientRect = ref.getBoundingClientRect;

    ref.getBoundingClientRect = () => {
      const original = ref._getBoundingClientRect();

      return {
        ...original,
        width: Math.floor(original.width),
        height: Math.floor(original.height),
      };
    };
  }
}

// Shift+wheel reaches us with the axes already swapped: the browser puts the
// sideways intent in deltaX and leaves deltaY at 0. perfect-scrollbar swaps
// them a second time in its own wheel handler ("reverse axis with shift key"),
// so the gesture lands back on the vertical axis and a table wider than its
// card can never be scrolled right. Claim the gesture in the capture phase,
// before that handler runs, and move the one axis the user asked for.
const bindShiftWheelScroll = (container) => {
  if (!container || container._shiftWheelScrollBound) return;
  container._shiftWheelScrollBound = true;

  container.addEventListener(
    "wheel",
    (event) => {
      if (!event.shiftKey) return;

      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      if (maxScrollLeft <= 0) return;

      // Whichever axis the browser used, Shift+wheel means "scroll sideways".
      const delta = event.deltaX || event.deltaY;
      container.scrollLeft = Math.min(Math.max(container.scrollLeft + delta, 0), maxScrollLeft);

      // Held even once we are hard against an edge: handing the gesture on
      // would only let perfect-scrollbar flip it into a vertical scroll, so a
      // sideways gesture over a sideways-scrolling table stays sideways.
      event.preventDefault();
      // perfect-scrollbar binds its handler to this same element, so stopping
      // propagation alone would not keep the event away from it.
      event.stopImmediatePropagation();
    },
    { capture: true, passive: false }
  );
};

const isRequired = (requiredObject, field) => {
  return requiredObject[field]?.required
}

const popularCountrySort = ["India", "United States", "United Arab Emirates", "Singapore", "United Kingdom", "Canada"]

// const linkedInTestURL = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/
// const linkedInTestURL = /linkedin\.com\/[a-zA-Z0-9_-]+\/?$/
const linkedInTestURL = /linkedin\.com\/.*$/


// function stringAvatar(current_name) {
//   let name = (current_name)?.length > 0 ? String(current_name)?.replace(" ", "") : ""
//   if (name && name?.includes(" ")) {
//     return {
//       sx: {
//         bgcolor: "#F9F5FF",
//         color: "#3538CD",
//         width: "40px",
//         height: "40px",
//         fontSize: '1rem',
//         textTransform: 'capitalize'
//       },
//       children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
//     };
//   } else if (name && !(name?.includes(" "))) {
//     return {
//       sx: {
//         bgcolor: "#F9F5FF",
//         color: "#3538CD",
//         width: "40px",
//         height: "40px",
//         fontSize: '1rem',
//         textTransform: 'capitalize'
//       },
//       children: name[0],
//     };
//   }
//   else {
//     return {
//       sx: {
//         bgcolor: "#F9F5FF",
//         color: "#3538CD",
//         width: "40px",
//         height: "40px",
//         fontSize: '1rem',
//         textTransform: 'capitalize'
//       },
//       children: '',
//     }
//   }
// }

const stringAvatar = (name) => {
  const initials = name
    ? String(name)
      ?.split(' ')
      ?.map((n) => n[0])
      ?.join('')
      ?.toUpperCase()
    : '';
  return {
    sx: {
      bgcolor: "#F9F5FF",
      color: "#3538CD",
      width: "40px",
      height: "40px",
      fontSize: '1rem',
      textTransform: 'capitalize'
    },
    children: (initials)?.slice(0, 2),
  };
};

const capitalizedSentence = (sentence) => sentence && sentence?.length > 0 ? sentence?.split(' ')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)).join(' ') : '';

const handleCopyClick = (copyLink, copied = false, setCopied) => {
  // Perform the copy action (e.g., copying text to clipboard)
  navigator.clipboard.writeText(copyLink);

  // Change the state to show the clicked (copied) icon
  setCopied(true);

  // Optionally reset the icon back after a delay
  setTimeout(() => setCopied(false), 2000);
};

const interestOptions = (value) => {
  switch (value) {
    case '$': return [
      { label: '+ $1,000', value: "1000" },
      { label: '+ $2,000', value: "2000" },
      { label: '+ $3,000', value: "3000" },
      { label: '+ $5,000', value: "5000" },
      { label: '+ $10,000', value: "10000" },
    ];
    case '₹': return [
      { label: '+ ₹1,00,000', value: "100000" },
      { label: '+ ₹2,00,000', value: "200000" },
      { label: '+ ₹3,00,000', value: "300000" },
      { label: '+ ₹5,00,000', value: "500000" },
      { label: '+ ₹10,00,000', value: "1000000" },
    ];
    default: return [
      { label: '+ ₹1,00,000', value: "100000" },
      { label: '+ ₹2,00,000', value: "200000" },
      { label: '+ ₹3,00,000', value: "300000" },
      { label: '+ ₹5,00,000', value: "500000" },
      { label: '+ ₹10,00,000', value: "1000000" },
    ];
  }
}

const ones = [
  '',
  'One ',
  'Two ',
  'Three ',
  'Four ',
  'Five ',
  'Six ',
  'Seven ',
  'Eight ',
  'Nine ',
  'Ten ',
  'Eleven ',
  'Twelve ',
  'Thirteen ',
  'Fourteen ',
  'Fifteen ',
  'Sixteen ',
  'Seventeen ',
  'Eighteen ',
  'Nineteen '
];
const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const largeUnits = ['Billion', 'Million', 'Thousand', '']; // Adjust for international units

export const convertToIndianCurrencyWords = (number) => {
  // if (number != undefined) {
  if (typeof number === 'number') {
    number = number.toString();
  }
  if (number === undefined || typeof number !== 'string') {
    return 'Please provide a valid input';
  }
  number = number.replace(/,/g, '');
  const parts = number.split('.');
  let integerPart = parts[0];
  let decimalPart = parts[1];
  number = integerPart;
  // console.log(parts[1], "parts[1]")

  if ((number = number.toString()).length > 13) return '';
  const n = ('0000000000000' + number).substr(-13).match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

  if (!n) return '';


  let str = '';
  str += n[1] !== '00' ? (
    (ones[Number(n[1])] || tens[n[1][0]] + ' ' + ones[n[1][1]]) +
    (n[2] === "00" ? 'Thousand Crore ' : 'Thousand ')
  ) : '';


  str += n[2] !== '00' ? (
    (ones[Number(n[2])] || tens[n[2][0]] + ' ' + ones[n[2][1]]) +
    (n[3] === "00" ? 'Hundred Crore ' : 'Hundred ')
  ) : '';

  str += n[3] !== '00' ? (ones[Number(n[3])] || tens[n[3][0]] + ' ' + ones[n[3][1]]) + 'Crore ' : '';
  str += n[4] !== '00' ? (ones[Number(n[4])] || tens[n[4][0]] + ' ' + ones[n[4][1]]) + 'Lakh ' : '';
  str += n[5] !== '00' ? (ones[Number(n[5])] || tens[n[5][0]] + ' ' + ones[n[5][1]]) + 'Thousand ' : '';
  str += n[6] !== '0' ? (ones[Number(n[6])] || tens[n[6][0]] + ' ' + ones[n[6][1]]) + 'Hundred ' : '';
  str += n[7] !== '00' ? (str !== '' ? ' ' : '') + (ones[Number(n[7])] || tens[n[7][0]] + ' ' + ones[n[7][1]]) : '';

  return str.trim() + (decimalPart != "00" && decimalPart != undefined ? " Point " + convertToIndianCurrencyWords(decimalPart) : "") || null;
  // }
  // else{
  //     return ""
  // }
};

export const convertToDollarWords = (number) => {
  if (typeof number === 'number') {
    number = number.toString();
  }
  if (number === undefined || typeof number !== 'string') {
    return 'Please provide a valid input';
  }
  number = number.replace(/,/g, '');
  const parts = number.split('.');
  let integerPart = parts[0];
  let decimalPart = parts[1];
  number = integerPart;

  if (number.length > 12) return ''; // limit to billions

  const n = ('000000000000' + number).substr(-12).match(/^(\d{3})(\d{3})(\d{3})(\d{3})$/);
  if (!n) return '';

  let str = '';
  str += n[1] !== '000' ? convertThreeDigitToWords(n[1]) + 'Billion ' : '';
  str += n[2] !== '000' ? convertThreeDigitToWords(n[2]) + 'Million ' : '';
  str += n[3] !== '000' ? convertThreeDigitToWords(n[3]) + 'Thousand ' : '';
  str += n[4] !== '000' ? convertThreeDigitToWords(n[4]) : '';

  return str.trim() + (decimalPart != "00" && decimalPart !== undefined ? " Point " + convertDecimalToWords(decimalPart) : "") || null;
};

function convertThreeDigitToWords(number) {
  const hundreds = Math.floor(number / 100);
  const remainder = number % 100;
  let str = '';

  if (hundreds > 0) {
    str += ones[hundreds] + 'Hundred ';
  }
  if (remainder > 0) {
    str += remainder < 20 ? ones[remainder] : tens[Math.floor(remainder / 10)] + ones[remainder % 10];
  }
  return str;
}

function convertDecimalToWords(decimalPart) {
  return decimalPart.split('').map(digit => ones[parseInt(digit)]).join('').trim();
}

const amountInWords = (value, currency) => {
  switch (currency) {
    case '$': return convertToDollarWords(value);
    case '₹': return convertToIndianCurrencyWords(value);
    default: return convertToIndianCurrencyWords(value);
  }
}

const scrollToFirstVisibleValidation = () => {
  // Query all elements with the class "validation-message"
  const validationMessages = document.querySelectorAll('.validation-message');
  // console.log(validationMessages, "dddd")

  // Find the first visible validation message
  for (const message of validationMessages) {
    if (message && message.offsetParent !== null) {
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
      break;
    }
  }
};

const handleFormSubmit = async (e, formik) => {
  e.preventDefault();
  const isValid = await formik.validateForm(); // Validate form before submission

  if (Object.keys(isValid).length > 0) {
    // If validation errors exist, trigger scroll
    formik.setTouched(isValid); // Mark all fields as touched
    setTimeout(() => {
      scrollToFirstVisibleValidation();
    }, 10)
  } else {
    formik.handleSubmit(); // Submit if there are no errors
  }
}

const notEmpty = (value) => {
  return !(value === null || value === undefined || value === '' || (typeof value == "string" && value?.trim()?.length === 0) ||
    (Array.isArray(value) && value.length === 0) ||
    (!(value instanceof Date) && typeof value === 'object' && Object.keys(value).length === 0));
}

function convertCurrencyAmountRange(amount, currency, noofDecimal = 2) {
  let result = '';

  if (amount != null) {
    // Check the currency type
    if (currency === 'INR') {
      if (amount >= 10000000) {
        result = (amount / 10000000).toFixed(noofDecimal) + 'Cr'; // Crores (10 million)
      } else if (amount >= 100000) {
        result = (amount / 100000).toFixed(noofDecimal) + 'L'; // Lakhs (100 thousand)
      } else if (amount >= 1000) {
        result = (amount / 1000).toFixed(noofDecimal) + 'K'; // Thousands
      } else {
        result = amount.toString(); // No conversion for smaller amounts
      }
    } else if (currency) {
    // USD and every other configured currency (EUR, GBP, AED...) use K/M
      if (amount >= 1000000) {
        result = (amount / 1000000).toFixed(noofDecimal) + 'M'; // Millions
      } else if (amount >= 1000) {
        result = (amount / 1000).toFixed(noofDecimal) + 'K'; // Thousands
      } else {
        result = amount.toString(); // No conversion for smaller amounts
      }
    } else {
      result = 'Invalid currency type';
    }
  }

  return result;
}

// Symbols match the `code` values of the investement_amount config
const CURRENCY_SYMBOLS = {
  INR: '₹', USD: '$', EUR: '€', GBP: '£', AED: 'د.إ', SAR: '﷼', SGD: 'S$',
  AUD: 'A$', CAD: 'C$', CHF: 'CHF', JPY: '¥', CNY: '¥', HKD: 'HK$', NZD: 'NZ$',
};

const getCurrencySymbol = (currency, fallback = '') => CURRENCY_SYMBOLS[currency] ?? fallback;

const getINRMarks = () => [
  // { value: 0, label: '< 5L', selectedValue: 0 },
  { value: 0, label: '₹5L', selectedValue: 500000 },
  { value: 1, label: '₹25L', selectedValue: 2500000 },
  { value: 2, label: '₹50L', selectedValue: 5000000 },
  { value: 3, label: '₹2CR', selectedValue: 20000000 },
  { value: 4, label: '₹5CR', selectedValue: 50000000 },
  { value: 5, label: '₹20CR', selectedValue: 200000000 },
  { value: 6, label: '₹50CR +', selectedValue: 500000000 },
];

const getUSDMarks = () => [
  { value: 0, label: '$10K', selectedValue: 10000 },
  { value: 1, label: '$50K', selectedValue: 50000 },
  { value: 2, label: '$100K', selectedValue: 100000 },
  { value: 3, label: '$250K', selectedValue: 250000 },
  { value: 4, label: '$500K', selectedValue: 500000 },
  { value: 5, label: '$1M', selectedValue: 1000000 },
  { value: 6, label: '$5M', selectedValue: 5000000 },
  { value: 7, label: '$10M', selectedValue: 10000000 },
  // { value: 7, label: '> 10M', selectedValue: 10000001 },
];

const getMarks = (currency) => {
  return currency === 'INR' ? getINRMarks(currency) : getUSDMarks(currency)
}

const technologyColor = "#FFF8DE"
const consumerBrandColor = "#FFE3E3"
const marketplaceColor = "#F2FFE9"
const servicesColor = "#F5EFFF"
const sectorAgnostic = "#F0EBE3"

const colorArray = [
  "#D4F6FF",
  "#F6EFBD",
  "#FFE3E3",
  "#FFECC8",
  "#EDE8DC",
  "#F5EFFF",
  "#FEF9D9",
  "#F6EACB",
  "#FAF4B7",
  "#FFE6E6",
  "#FFF8DE",
  "#FFE8C5",
  "#F5EEE6",
  "#F2FFE9",
  "#F8E8EE",
  "#F8EDE3",
  "#F0EBE3",
  "#FEF2F4",
]

const isTitleToShow = (title) => {
  return ["Dr.", "CA"].includes(title)
}

// const investor_types = [
//   { label: "Angel", value: "angel" },
//   { label: "Super Angel", value: "super_angel" },
//   { label: "Micro VC", value: "micro_vc" },
//   { label: "VC", value: "vc" },
//   { label: "Family Office", value: "family_office" },
//   { label: "Accelerator", value: "accelerator" },
//   { label: "Incubator", value: "incubator" },
//   { label: "Investment Banker", value: "investment_banker" },
//   {
//     label: "Angel Network / Syndicate", value: "syndicate"
//   }
// ];

const isSelectedInvestorGroup = ({ type, investor_types = [] }) => {
  // console.log(investor_types?.at(6), investor_types?.at(5))
  if (investor_types?.length > 0) {
    switch (type) {
      case investor_types?.at(5)?.value:
        // accelerator
        return true;
      case investor_types?.at(6)?.value:
        // incubator
        return true;
      default:
        return false
    }
  }
  else {
    return false;
  }
}

const websiteTestURL = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const validateSubscriptionAndInvoiceURL = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/.*)?$/;
// const downloadFile = (url) => {
//   const link = document.createElement('a');
//   link.href = url;
//   link.target = '_blank';
//   link.setAttribute('download', 'filename.pdf'); // Specify the desired filename here
//   link.click();
// }
const downloadFile = (url) => {
  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob(); // Convert the response to a Blob
    })
    .then(blob => {
      const link = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);

      // Extract the original filename from the URL
      const urlParts = url.split('/');
      const filename = urlParts[urlParts.length - 1] || 'downloaded_file';

      link.href = objectUrl;
      link.setAttribute('download', filename); // Use the extracted filename
      document.body.appendChild(link); // Append the link to the DOM
      link.click(); // Trigger the download
      document.body.removeChild(link); // Clean up the DOM
      URL.revokeObjectURL(objectUrl); // Release the Blob URL
    })
    .catch(error => {
      console.error('Error downloading file:', error);
    });
};

const mergePermissions = ({ fetchedPermissions, permissionsTemplate }) => {
  return permissionsTemplate ? Object.fromEntries(
    Object.entries(permissionsTemplate).map(([module, { label, actions }]) => [
      module,
      {
        label,
        actionLabels: actions, // Keep the action labels as is
        actions: Object.fromEntries(
          Object.keys(actions).map((action) => [
            action,
            fetchedPermissions && fetchedPermissions[module]
              ? fetchedPermissions[module][action] ?? false // Check if fetchedPermissions is valid
              : false  // Default to false if fetchedPermissions is null or empty
          ])
        )
      }
    ])
  ) : {};
};

const defaultPermissions = ({ permissionsTemplate }) => {
  return mergePermissions({ permissionsTemplate: permissionsTemplate, fetchedPermissions: { profile: { view: true } } })
};

const adminDefaultPermissions = ({ permissionsTemplate }) => {
  return Object.entries(defaultPermissions({ permissionsTemplate }))?.reduce((acc, [module, item]) => {
    const updatedActions = Object.keys(item?.actions || {}).reduce((actionsAcc, action) => {
      // console.log(actionsAcc, action)
      actionsAcc[action] = true;
      return actionsAcc;
    }, {});


    acc[module] = {
      ...item,
      actions: updatedActions
    };
    return acc;
  }, {});
}

const collaboratorDefaultPermissions = ({ permissionsTemplate }) => {
  return Object.entries(defaultPermissions({ permissionsTemplate }))?.reduce((acc, [module, item]) => {
    const updatedActions = Object.keys(item?.actions || {}).reduce((actionsAcc, action) => {
      if (module === "profile" && action === "view") {
        actionsAcc[action] = true;
      }
      else {
        actionsAcc[action] = false;
      }

      return actionsAcc;
    }, {});

    acc[module] = {
      ...item,
      actions: updatedActions
    };
    return acc;
  }, {});
}

function convertToPermissionOnly(permissions) {
  const savedPermissions = {}
  Object.keys(permissions)?.map((key) => {
    savedPermissions[key] = permissions[key]["actions"]
  });
  return savedPermissions
}

const adminPermission = ({ permissionsTemplate }) => {
  return convertToPermissionOnly(adminDefaultPermissions({ permissionsTemplate }))
};

/**
 * Get permission value for a given module and key.
 * 
 * @param {"profile"|"startups"|"startups_new"|"portfolio"|"reports"|"settings"} module - The name of the module.
 * @param {string} key - The permission key within the module.
 * @param {Object} permissions - The permissions object.
 * @returns {boolean} - The permission value or false if not found.
 */
function hasPermission(module, key, permissions) {
  // console.log(permissions, module, key, "permissions")
  // if (module === "startups_new" && key === "edit") {
  //   console.log(permissions, "ello", key in permissions[module], permissions[module][key])
  // }
  // if (module === "startups_new" && key === "edit") {
  //   console.log(permissions, permissions[module], "permissions")
  // }
  return permissions && permissions[module] && key in permissions[module]
    ? permissions[module][key]
    : false;  // Default for non-existing keys
}


/**
 * Check if a user has permission for a specific route.
 * 
 * @param {Object} userPermissions - An object containing user permissions for various modules.
 * @param {string} route - The route to check permission for.
 * @returns {boolean} - True if the user has permission for the route, false otherwise.
 */
function hasPermissionForRoute(userPermissions, route) {
  const backrrPermissionCookie = userPermissions || null;
  // if (route?.includes("claim-profile")) {
  //   return true;
  // }
  // console.log(userPermissions, "userPermissions")
  // if (route?.startsWith("backrr_startups") && backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_startups) {
  //   return true;
  // }
  // if (route?.startsWith("backrr_investors") && backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_investors) {
  //   return true;
  // }
  // if (route?.startsWith("admin_settings") && backrrPermissionCookie && (JSON.parse(backrrPermissionCookie)?.backrr_admin_settings_release_notes || JSON.parse(backrrPermissionCookie)?.backrr_admin_settings_admin_users)) {
  //   return true;
  // }
  // if (route?.startsWith("admin_settings/release_notes") && backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_admin_settings_release_notes) {
  //   return true;
  // }
  // if (route?.startsWith("admin_settings/admin_users") && backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_admin_settings_admin_users) {
  //   return true;
  // }
  if (!userPermissions || Object.keys(userPermissions).length === 0) {
    return false;  // Handle null, undefined, or empty userPermissions
  }

  const routeToModuleMap = {
    '/': { module: 'startups', key: 'view' },
    '/deal-flow': { module: 'startups', key: 'view' },
    '/deal-flow/view-profile': { module: 'startups', key: 'view' },
    '/deal-flow/view-round': { module: 'startups', key: 'view' },
    '/deal-flow/view-documents': { module: 'startups', key: 'view' },
    '/deal-flow/view-funding': { module: 'startups', key: 'view' },
    '/deal-flow/view-reports': { module: 'startups', key: 'view' },
    '/deal-flow/view-performance': { module: 'startups', key: 'view' },
    '/deal-flow/view-feedback': { module: 'startups', key: 'submit_feedback' },
    '/deal-flow/view-notes': { module: 'startups', key: 'manage_internal_notes' },
    '/startups': { module: 'startups_new', key: 'view' },
    '/startups/add': { module: 'startups_new', key: 'add' },
    '/startups/edit': { module: 'startups_new', key: 'edit' },
    '/startups/rounds/view-round': { module: 'startups_new', key: 'view' },
    '/startups/rounds/add-round': { module: 'startups_new', key: 'edit' },
    '/startups/rounds/edit-round': { module: 'startups_new', key: 'edit' },
    '/startups/rounds/view': { module: 'startups_new', key: 'view' },
    '/startups/rounds/view-investors': { module: 'startups_new', key: 'view' },
    '/startups/rounds/view-documents': { module: 'startups_new', key: 'view' },
    '/startups/view-profile': { module: 'startups_new', key: 'view' },
    '/startups/view-round': { module: 'startups_new', key: 'view' },
    '/startups/view-documents': { module: 'startups_new', key: 'view' },
    '/startups/rounds': { module: 'startups_new', key: 'view' },
    '/startups/reports': { module: 'startups_new', key: 'view' },
    '/startups/reports/add-report': { module: 'startups_new', key: 'view' },
    '/startups/reports/edit-report': { module: 'startups_new', key: 'view' },
    '/startups/performance': { module: 'startups_new', key: 'view' },
    '/startups/performance/add-performance': { module: 'startups_new', key: 'add' },
    '/startups/performance/edit-performance': { module: 'startups_new', key: 'edit' },
    '/startups/users': { module: 'startups_new', key: 'edit' },
    '/startups/users/add-user': { module: 'startups_new', key: 'edit' },
    '/startups/users/edit-user': { module: 'startups_new', key: 'edit' },
    '/startups/view-feedback': { module: 'startups_new', key: 'view' },
    '/startups/email-logs': { module: 'startups_new', key: 'view' },
    '/startups/profile-views': { module: 'startups_new', key: 'view' },
    '/startups/matched-investors': { module: 'startups_new', key: 'view' },
    // '/startups/find-investors': { module: 'startups_new', key: 'view' },
    '/startups/view-notes': { module: 'startups_new', key: 'view' },
    // '/startups/view-feedback': { module: 'startups_new', key: 'submit_feedback' },
    // '/startups/view-notes': { module: 'startups_new', key: 'manage_internal_notes' },
    '/profile': { module: 'profile', key: 'view' },
    '/profile/edit_profile': { module: 'profile', key: 'edit' },
    '/portfolio': { module: 'portfolio', key: 'view' },
    '/portfolio/create_portfolio': { module: 'portfolio', key: 'add' },
    '/portfolio/create_portfolio': { module: 'portfolio', key: 'edit' },
    '/reports': { module: 'reports', key: 'view' },
    '/reports/view': { module: 'reports', key: 'view' },
    '/settings': { module: 'settings', key: 'manage_users' },
    '/settings/add_user': { module: 'settings', key: 'manage_users' },
  };

  const routeInfo = routeToModuleMap[route];

  if (!routeInfo) {
    return false;  // Route not mapped
  }

  const { module, key } = routeInfo;
  return hasPermission(module, key, userPermissions);
}

function findFirstTrueValue(permissions) {
  for (const module in permissions) {
    const keys = permissions[module];
    for (const key in keys) {
      if (keys[key] === true) {
        return { module, key };  // Return the first match found
      }
    }
  }
  return null;  // Return null if no true value is found
}

function getFirstRoute({ module, key }) {
  switch (module) {
    case 'profile':
      return `/`;
    case 'funding_rounds':
      return `/rounds`
    case 'reports':
      return `/reports`
    case 'performance':
      return `/performance`
    case 'find_investors':
      return `/find-investors`
    case 'settings':
      return `/settings`
    default:
      return '/'
  }
}

// function hasPermissionForRoute(userPermissions, route) {
//   console.log(userPermissions,"userPermissions")
//   if (!userPermissions || Object.keys(userPermissions).length === 0) {
//     return false;  // Handle null, undefined, or empty userPermissions
//   }

//   const routeToModuleMap = {
//     '/': 'profile',
//     '/update': 'profile',
//     '/rounds': 'funding_rounds',
//     '/reports': 'reports',
//     '/performance': 'performance',
//     '/find-investors': 'find_investors',
//     '/settings': 'settings',
//   };

//   const module = routeToModuleMap[route];

//   if (!module || !userPermissions[module]) {
//     return false;  // Route not mapped or no permissions for the module
//   }

//   const permissions = userPermissions[module];
//   console.log(userPermissions, route, module)
//   return Object.values(permissions).some(permission => permission === true);
// }

const formatCurrency = (value, locale = "en-In") => {
  if (!value) return "";

  // Remove invalid characters except numbers and decimal
  const cleanValue = String(value)?.replace(/[^0-9.]/g, "");

  // Allow only two digits after the decimal point
  const parts = cleanValue?.split(".");
  if (parts?.length > 1) {
    parts[1] = parts[1]?.slice(0, 2); // Keep only first 2 digits after '.'
  }

  // Join the integer and decimal parts back
  const truncatedValue = parts?.join(".");

  // Format the integer part with commas
  const [integerPart, decimalPart] = truncatedValue?.split(".");
  const formattedInteger = parseInt(integerPart || "0", 10)?.toLocaleString(locale);

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

const formatDecimal = (value) => {
  if (!value) return "";

  // Remove invalid characters except numbers and decimal
  const cleanValue = String(value)?.replace(/[^0-9.]/g, "");

  // Allow only two digits after the decimal point
  const parts = cleanValue.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2); // Keep only the first 2 digits after '.'
  }

  // Join the integer and decimal parts back
  return parts.join(".");
};

const currencyAllowNegativeInputProps = {
  inputMode: "decimal", // Use numeric keyboard with decimal support on mobile devices
  pattern: "-?[0-9.]*", // Allow digits 0-9, '.', and '-'
  onKeyDown: (event) => {
    const { key, target } = event;

    // Prevent invalid characters: 'e', 'E', multiple '-' or '.'
    if (key === "e" || key === "E") {
      event.preventDefault();
    }

    // Prevent multiple '-' (only one allowed at the start)
    if (key === "-" && target.selectionStart !== 0) {
      event.preventDefault();
    }

    // Prevent multiple '.' characters
    if (key === "." && target.value.includes(".")) {
      event.preventDefault();
    }
  },
  onInput: (event) => {
    // Get the input value
    const inputValue = event.target.value;

    // Remove invalid characters except numbers, '.' and '-'
    let numericValue = inputValue.replace(/[^0-9.-]/g, "");

    // Ensure only the first '-' is kept and at the start
    const isNegative = numericValue.startsWith("-");
    numericValue = numericValue.replace(/-/g, ""); // Remove all '-'
    if (isNegative) numericValue = `-${numericValue}`;

    // Ensure only one '.' is present
    const parts = numericValue.split(".");
    if (parts.length > 1) {
      numericValue = `${parts[0]}.${parts[1]}`;
    }

    // Update the input field value
    event.target.value = numericValue;
  },
  style: {
    textAlign: "center", // Optional: Center the text
  },
  disableUnderline: true,
};


const formatAllowsNegativeCurrency = (value, locale = "en-In") => {
  if (!value) return "";

  // Remove invalid characters except numbers, decimal, and negative sign
  const cleanValue = String(value)?.replace(/[^0-9.-]/g, "");

  // Ensure only the first `-` is kept and at the start
  const isNegative = cleanValue.startsWith("-");
  const numericValue = cleanValue.replace(/-/g, ""); // Remove all `-` signs
  const sanitizedValue = isNegative ? `-${numericValue}` : numericValue;

  // Allow only two digits after the decimal point
  const parts = sanitizedValue.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2); // Keep only the first 2 digits after '.'
  }

  // Join the integer and decimal parts back
  const truncatedValue = parts.join(".");

  // Format the integer part with commas
  const [integerPart, decimalPart] = truncatedValue.split(".");
  const formattedInteger = parseInt(integerPart || "0", 10).toLocaleString(locale);

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

const formatAllowsNegativeDecimal = (value) => {
  if (!value) return "";

  // Remove invalid characters except numbers, decimal, and negative sign
  const cleanValue = String(value)?.replace(/[^0-9.-]/g, "");

  // Ensure only the first `-` is kept and at the start
  const isNegative = cleanValue.startsWith("-");
  const numericValue = cleanValue.replace(/-/g, ""); // Remove all `-` signs
  const sanitizedValue = isNegative ? `-${numericValue}` : numericValue;

  // Allow only two digits after the decimal point
  const parts = sanitizedValue.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2); // Keep only the first 2 digits after '.'
  }

  // Join the integer and decimal parts back
  return parts.join(".");
};

const cookiesInUse = {
  'JWT': 'X-ADMIN-JWT',
  'USER-TYPE': 'X-ADMIN-USER-TYPE',
  'ADMIN-ID': 'X-ADMIN-ID',
}

const checkForUserType = () => {
  return Cookies.get(cookiesInUse["USER-TYPE"]);
}

const setUserType = (value, domain) => {
  if (domain) {
    return Cookies.set(cookiesInUse["USER-TYPE"], value, { domain: domain });
  }
  else {
    return Cookies.set(cookiesInUse["USER-TYPE"], value);
  }
}

const checkForAuthorization = () => {
  return Cookies.get(cookiesInUse["JWT"]);
}

const setTokenForAuthorization = (token, domain) => {
  // console.log(domain, "dddd")
  if (domain) {
    return Cookies.set(cookiesInUse["JWT"], token, { domain: domain });
  }
  else {
    return Cookies.set(cookiesInUse["JWT"], token);
  }
}

export const setAdminID = (id, domain) => {
  if (domain) {
    return Cookies.set(cookiesInUse["ADMIN-ID"], id, { domain: domain });
  }
  else {
    return Cookies.set(cookiesInUse["ADMIN-ID"], id);
  }
}

export const getAdminID = () => {
  return Cookies.get(cookiesInUse["ADMIN-ID"]);
}

function getTemplateKeyValue({ module, key = "label", template }) {
  // majorly used for getting labels from template.
  return template && template[module] && key in template[module]
    ? template[module][key]
    : "";  // Default for non-existing keys
}

const requiredProgressFields = [
  "logo_url", "entity_name", "formation_date", "stage_id", "category_id", "sector_id",
  "business_model_id", "problem_solving", "description", "website_url", "linkedin_url",
  "founder", "pitch_deck_url"
];

const progressLabels = {
  logo_url: "Logo",
  entity_name: "Legal Entity Name",
  formation_date: "Formation Date",
  stage_id: "Stage",
  sector_id: "Sector",
  category_id: "Category",
  business_model_id: "Business Model",
  problem_solving: "Problem Solved",
  description: "Startup Overview",
  website_url: "Website URL",
  linkedin_url: "LinkedIn Page",
  founder: "Founder Details",
  pitch_deck_url: "Pitch Deck",
  elevator_pitch: "Elevator Pitch Video",
  // round_name: "Round Name",
  // round_type: "Round Type",
  // security_type: "Security Type",
  // total_round_size: "Total Round Size",
  // round_valuation: "Round Valuation",
  // round_highlights: "Round Highlights",
  // key_metrics: "Key Metrics",
  documents: "Documents"
};

const roundNavigationFields = [
  "Round Name & Type", "Round Size & Valuation", "Fund Utilization", "Current Traction", "Documents", "Exit Strategy"
]

const getProgressLabel = (key) => progressLabels[key] ?? key;

const progressFieldsRoute = {
  Logo: "/update?page=0",
  "Legal Entity Name": "/update?page=0",
  "Formation Date": "/update?page=0",
  Stage: "/update?page=0",
  Sector: "/update?page=0",
  Category: "/update?page=0",
  "Business Model": "/update?page=0",
  "Problem Solved": "/update?page=2",
  "Startup Overview": "/update?page=2",
  "Website URL": "/update?page=1",
  "LinkedIn Page": "/update?page=1",
  "Founder Details": "/update?page=3",
  "Pitch Deck": "/update?page=2",
  "Elevator Pitch Video": "/update?page=2",
  "Round Name & Type": "/rounds/edit_round?page=0",
  "Round Size & Valuation": "/rounds/edit_round?page=1",
  "Fund Utilization": "/rounds/edit_round?page=3",
  "Current Traction": "/rounds/edit_round?page=4",
  Documents: "/rounds/edit_round?page=5",
  "Exit Strategy": "/rounds/edit_round?page=7",
  "Performance": "/performance"
};

const getProgressFieldRoute = (key) => progressFieldsRoute[key];

const formatProgressData = ({ response }) => {
  if (!response?.data) return { completion: 0, dataWithLabels: [], requiredFieldsLabels: [], dataWithLabelsObject: {} };

  const { completion, data } = response;
  const {
    round_id,
    round_name, round_type, security_type,
    total_round_size, round_valuation, received_termsheet, round_highlights,
    fund_utilization_highlights, key_metrics,
    traction_highlights,
    exit_highlights,
    documents,
    performanceCompletion,
    performance,
    ...rest
  } = data;

  const dataWithLabels = [
    ...Object.entries(rest).map(([key, value]) => ({ [getProgressLabel(key)]: value })),
    { "Round Name & Type": Boolean(round_name && round_type && security_type) && { round_name, round_type, security_type } },
    { "Round Size & Valuation": Boolean(total_round_size && round_valuation && received_termsheet) && { total_round_size, round_valuation, received_termsheet } },
    { "Fund Utilization": Boolean(fund_utilization_highlights && key_metrics) && { fund_utilization_highlights, key_metrics } },
    { "Current Traction": traction_highlights || false },
    { "Exit Strategy": exit_highlights || false },
    { Documents: documents || false },
    { Performance: performanceCompletion || false },
  ]
  // .filter((item) => Object.values(item)[0]); // Remove empty values

  const requiredFieldsLabels = requiredProgressFields.map(getProgressLabel);

  const dataWithLabelsObject = Object.assign({}, ...dataWithLabels);

  return { completion: completion || 0, round_id, dataWithLabels, requiredFieldsLabels, dataWithLabelsObject };
};

const getChangedFields = (currentValues, originalValues) => {
  return Object.keys(originalValues).reduce((changes, key) => {
    const formValue = currentValues[key];
    const originalValue = originalValues[key];

    // Simple comparison for primitives
    if (typeof formValue !== 'object' || formValue === null) {
      if (formValue !== originalValue) {
        changes[key] = { original: originalValue, current: formValue };
      }
    }
    // For objects, use JSON stringification
    else if (JSON.stringify(formValue) !== JSON.stringify(originalValue)) {
      changes[key] = { original: originalValue, current: formValue };
    }

    return changes;
  }, {});
};


const hasFormChanges = (currentValues, originalValues) => {
  // console.log(getChangedFields(currentValues, originalValues))
  return Object.keys(originalValues).some(key => {
    const formValue = currentValues[key];
    const originalValue = originalValues[key];

    // Simple comparison for primitives
    if (typeof formValue !== 'object' || formValue === null) {
      return formValue !== originalValue;
    }

    // For objects, use JSON stringification
    return JSON.stringify(formValue) !== JSON.stringify(originalValue);
  });
};

const profileProgress = [
  { id: 1, label: 'Below 25%', min: 0, max: 25, value: "below_25" },
  { id: 2, label: '25% to 50%', min: 25, max: 50, value: "25_to_50" },
  { id: 3, label: '50% to 75%', min: 50, max: 75, value: "50_to_75" },
  { id: 4, label: 'Above 75%', min: 75, max: 99, value: "above_75" },
  { id: 5, label: '100% Complete', min: 100, max: 100, value: "100_complete" }
];

const pageIndexCookie = () => {
  return Cookies.get("backrr_table_page")
}


export const typeOptions = [
  { label: "Admin", value: "admin" },
  { label: "Investor", value: "investor" },
  { label: "Startup", value: "startup" },
  { label: "Main Website", value: "main_website" },
]

export const plans = process.env.REACT_APP_MODE === "development" ? [
  { value: 'plan_PawMGJren5z8xO', label: 'Plus (Yearly)' },
  // { value: 'plan_PawMGJren5z8xd', label: 'Pro' },
  // Add more if needed
] : [
  { value: 'plan_QDKAI9fuvUqeRh', label: 'Plus (Yearly)' },
  // { value: 'plan_PawMGJren5z8xd', label: 'Pro' },
  // Add more if needed
];

const FREQUENCY_ORDER = ["monthly", "quarterly", "yearly"];

/** A plan's generation, from its key: plus is 1, plus_v2 is 2. */
const planVersion = (planType) => {
  const versioned = String(planType || "").match(/_v(\d+)$/);
  return versioned ? Number(versioned[1]) : 1;
};

/**
 * Keys that a later version has replaced. This reads the raw config rather than
 * the /subscriptions/plans response, so the version has to be worked out here
 * rather than taken from the API.
 */
const supersededPlanKeys = (plans) => {
  const superseded = new Set();

  Object.values(plans || {}).forEach((plan) => {
    if (plan?.replaces) {
      superseded.add(String(plan.replaces));
      return;
    }
    // Falls back to the key suffix for a config written before `replaces` was
    // recorded: plus_v2 supersedes plus.
    const versioned = String(plan?.plan_type || "").match(/^(.+)_v\d+$/);
    if (versioned) superseded.add(versioned[1]);
  });

  return superseded;
};

/**
 * The version to show against a plan, given the plans config. `showVersion` is
 * false for a plan that was never versioned — the free tier — where a "V1" badge
 * would imply a second version exists.
 */
export const planVersionInfo = (configData, planType) => {
  const version = planVersion(planType);
  const superseded = supersededPlanKeys(configData?.plans);

  return {
    version,
    showVersion: superseded.has(planType) || version > 1,
  };
};

export const transformPlans = (data) => {
  if (!data?.plans) return [];

  const { plans } = data;
  const supportedPlans = data?.billing?.supported_plans?.length
    ? data.billing.supported_plans
    : Object.keys(plans);

  const superseded = supersededPlanKeys(plans);

  return supportedPlans.flatMap((planType) => {
    const plan = plans[planType];

    if (!plan || !plan.enabled) return [];

    // An offer code is tied to a razorpay plan id, so only the frequencies a plan
    // actually sells can carry one. The yearly-only plans have no monthly or
    // quarterly plan id, and offering those combinations produces codes that can
    // never validate.
    const availableFrequencies = new Set(
      Object.values(plan.razorpay_config || {}).flatMap((regionConfig) =>
        Object.keys(regionConfig || {}),
      ),
    );

    // Plans that share a title across versions need the version to tell them
    // apart. One that was never versioned, like the free tier, gets no suffix.
    const version = planVersion(plan?.plan_type);
    const versionLabel =
      superseded.has(plan?.plan_type) || version > 1 ? ` (V${version})` : "";

    return FREQUENCY_ORDER.filter((frequency) =>
      availableFrequencies.has(frequency),
    ).map((frequency) => ({
      label: `${plan?.title} ${capitalize(frequency)}${versionLabel}`,
      value: `${plan?.plan_type}_${frequency}`,
      frequency,
      plan_type: planType,
      // Carried separately so callers can compose their own label — the offer
      // listing renders the plan and its frequency as one chip.
      plan_title: plan?.title,
      version,
    }));
  }).sort((a, b) => b.version - a.version);
};

const capitalize = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const source_list = [
  { label: "Startup Profile", value: "startup_profile" },
  { label: "Pitch Deck", value: "pitch_deck" },
  { label: "Dashboard", value: "dashboard" },
  { label: "Investor Profile", value: "investor_profile" },
  { label: "Application Form", value: "application_form" },
  { label: "Resources", value: "resources" },
  { label: "Fundability Report", value: "fundability_report" },
  { label: "Pitch Report", value: "pitchdeck_report" },
]

export {
  pageIndexCookie,
  chartsColorsTheme,
  getDeviceType,
  redirectTo,
  navigateToMain,
  singleSignOn,
  handleDateValues,
  getFileIcon,
  getFileCategory,
  containerRef,
  bindShiftWheelScroll,
  isRequired,
  popularCountrySort,
  linkedInTestURL,
  stringAvatar,
  capitalizedSentence,
  handleCopyClick,
  interestOptions,
  notEmpty,
  formatAllowsNegativeCurrency,
  formatDecimal,
  formatCurrency,
  currencyAllowNegativeInputProps,
  formatAllowsNegativeDecimal,
  currencyInputProps,
  versionInputProps,
  versionCheck,
  amountInWords,
  handleFormSubmit,
  convertCurrencyAmountRange,
  getCurrencySymbol,
  getINRMarks,
  getUSDMarks,
  getMarks,
  technologyColor,
  consumerBrandColor,
  marketplaceColor,
  servicesColor,
  sectorAgnostic,
  colorArray,
  isTitleToShow,
  // investor_types,
  isSelectedInvestorGroup,
  websiteTestURL,
  downloadFile,
  // permissions 
  mergePermissions,
  defaultPermissions,
  adminDefaultPermissions,
  collaboratorDefaultPermissions,
  convertToPermissionOnly,
  adminPermission,
  hasPermission,
  hasPermissionForRoute,
  findFirstTrueValue,
  getFirstRoute,
  checkForAuthorization,
  setTokenForAuthorization,
  checkForUserType,
  setUserType,
  getTemplateKeyValue,
  navigateToDomain,
  hasFormChanges,
  profileProgress,
  formatProgressData,
  dealFlowStatuses,
  checkForEmail,
  getBucketUrl,
  extractMainDomain
  // InvestorsList
}